import React from "react";
import Marquee from "react-fast-marquee";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";

// Components //
import TitleSection from "../../molecules/title-section";
import ThumbnailImage from "../../atoms/thumbnail-image/thumbnailImage";

// Styles //
import "./communitiesCompanies.scss";

const CommunitiesCompanies = (props: ReferenciaContenido) => {
    const { tituloGeneral, referenciaPlantillaContenido: refPlantilla } = props;


    return (
        <div className="o-communities-companies">
            <div className="container">
                <div className="o-communities-companies__container">
                    <div className="o-communities-companies__container__title">
                        <TitleSection title={tituloGeneral} />
                    </div>
                    <div className="o-communities-companies__container__slider">
                        <Marquee gradient={false} speed={30} direction="right">
                            <div className="companies-marquee">
                                {refPlantilla[0].imagenPrincipal.map(
                                    (image, i) => (
                                        <div
                                            className="companies-marquee__item"
                                            key={i}
                                        >
                                            <ThumbnailImage
                                                src={image.file.url}
                                                alt={image.title}
                                            />
                                        </div>
                                    )
                                )}
                            </div>
                        </Marquee>
                        <Marquee gradient={false} speed={30} direction="left">
                            <div className="companies-marquee">
                                {refPlantilla[0].imagenPrincipal.map(
                                    (image, i) => (
                                        <div
                                            className="companies-marquee__item"
                                            key={i}
                                        >
                                            <ThumbnailImage
                                                src={image.file.url}
                                                alt={image.title}
                                            />
                                        </div>
                                    )
                                )}
                            </div>
                        </Marquee>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CommunitiesCompanies;
